/**
 * Extracted from snippets/ns-upsell-upgrades.liquid (inline <script> at line 272).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at snippets/ns-upsell-upgrades.liquid:272) ---
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ns-updgrade-add-to-cart').forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        if (this.getAttribute('aria-disabled') === 'true') {
          return;
        }

        const variantId = this.getAttribute('data-variant-id');

        if (!variantId) {
          console.warn('No variant ID found on clicked element.');
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(data => {
          console.log('Product added:', data);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          const upgradeContainer = button.closest('.upgrade-container');
            if (upgradeContainer) {
              upgradeContainer.classList.add('item-added');
            }

        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });
      });
    });

    document.addEventListener('cart:change', function () {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Loop through all upgrade buttons
          document.querySelectorAll('.ns-updgrade-add-to-cart').forEach(function (button) {
            const variantId = parseInt(button.getAttribute('data-variant-id'), 10);
            const container = button.closest('.upgrade-container');

            if (!variantId || !container) return;

            const variantInCart = cart.items.some(item => item.variant_id === variantId);

            if (!variantInCart) {
              container.classList.remove('item-added');
            }
          });
        })
        .catch(error => {
          console.error('Failed to fetch cart:', error);
        });
    });



  // Your code here





  });
})();
